
import { defineComponent, ref } from "vue";

export default /*#__PURE__*/ defineComponent({
  name: "VideoComponent",
  props: {
    videoId: String,
  },
  setup() {
    const showPlayIcon = ref(false);
    const onPlay = () => {
      showPlayIcon.value = false;
    };
    const onReady = () => {
      showPlayIcon.value = true;
    };

    return { showPlayIcon, onPlay, onReady };
  },
});
